import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__topic" };
const _hoisted_4 = { class: "data-item__title" };
const _hoisted_5 = { class: "data-item__actions" };
const _hoisted_6 = { class: "data-item__content" };
const _hoisted_7 = {
    key: 0,
    class: "data-item__section"
};
const _hoisted_8 = { class: "data-item__section-title" };
const _hoisted_9 = { class: "form__buttons" };
const _hoisted_10 = {
    type: "submit",
    class: "button button--primary"
};
import { onMounted, ref } from 'vue';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import importProfileRepository from "../services/ShopImportProfileRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import { clone } from 'lodash';
import { saveShopImportProfile } from "../commands/SaveShopImportProfile";
import FormValidator from "@astina/paloma-common-ui/src/components/form/FormValidator";
import trans from '@astina/paloma-common-ui/src/services/Translator';
import { useRoute, useRouter } from "vue-router";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileEditView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const form = createFormConfig();
        const profile = ref(null);
        const draft = ref(null);
        const validation = ref({ errors: [], fields: {} });
        const templateSettingsValidation = ref({ errors: [], fields: {} });
        const template = ref(null);
        onMounted(() => {
            loadProfile()
                .then(() => draft.value = createDraft())
                .then(() => template.value = profile.value._meta.template || null);
        });
        function saveImportProfile() {
            saveShopImportProfile(draft.value)
                .then(profile => profile.value = profile)
                .then(() => {
                router.push({ name: 'integration_import_details', params: { id: profile.value?.id } });
            })
                .catch((v) => {
                validation.value = v;
                templateSettingsValidation.value = FormValidator.extractNestedValidation(v, 'templateSettings');
            });
        }
        function createDraft() {
            const draft = profile.value;
            if (!draft.templateSettings) {
                draft.templateSettings = {};
            }
            return clone(draft);
        }
        function loadProfile() {
            const id = RouterUtils.singleParam(route, 'id');
            return importProfileRepository
                .get(id)
                .then(p => {
                profile.value = p;
            });
        }
        function createFormConfig() {
            return {
                name: 'import_profile',
                fields: [
                    {
                        name: 'name',
                        label: trans('import_profile.name'),
                        type: 'text',
                        options: {
                            required: true,
                            maxLength: 255,
                        }
                    },
                    {
                        name: 'status',
                        label: trans('import_profile.status'),
                        type: 'choice',
                        options: {
                            required: true,
                            expanded: true,
                            choices: [
                                {
                                    value: 'active',
                                    label: 'active',
                                },
                                {
                                    value: 'inactive',
                                    label: 'inactive',
                                },
                            ]
                        }
                    },
                ],
            };
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_form_fields = _resolveComponent("form-fields");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    (profile.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('import_profile.edit')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(profile.value.name), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_import_details', params: { id: profile.value.id } },
                                    class: "button button--outline"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["to"])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !profile.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    (draft.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(saveImportProfile, ["prevent"]),
                                class: "form form--simple",
                                novalidate: ""
                            }, [
                                _createVNode(_component_form_fields, {
                                    form: _unref(form),
                                    fields: _unref(form).fields,
                                    data: draft.value,
                                    validation: validation.value
                                }, null, 8, ["form", "fields", "data", "validation"]),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                (template.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('import_profile.template_settings')), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        _createVNode(_component_form_fields, {
                                            form: template.value.info.form,
                                            fields: template.value.info.form.fields,
                                            data: draft.value.templateSettings,
                                            validation: templateSettingsValidation.value
                                        }, null, 8, ["form", "fields", "data", "validation"])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("button", _hoisted_10, [
                                        _createVNode(Icon, { name: "save" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('save')), 1)
                                    ]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createVNode(_component_router_link, {
                                        to: { name: 'integration_import_details', params: { id: profile.value?.id } },
                                        class: "button button--link button--cancel"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["to"])
                                ])
                            ], 32)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
